<template>
  <a-space>
    <template v-for="action in visibleActions" :key="action.key">
      <a-popconfirm
        v-if="action.confirm"
        :title="action.confirm"
        :ok-text="t('common.ok')"
        :cancel-text="t('common.cancel')"
        @confirm="handleClick(action)"
      >
        <a-button
          :type="getButtonType(action.type)"
          :danger="action.type === 'danger'"
          size="small"
          :disabled="isDisabled(action)"
        >
          <template v-if="action.icon" #icon>
            <component :is="action.icon" />
          </template>
          {{ action.label }}
        </a-button>
      </a-popconfirm>
      
      <a-button
        v-else
        :type="getButtonType(action.type)"
        :danger="action.type === 'danger'"
        size="small"
        :disabled="isDisabled(action)"
        @click="handleClick(action)"
      >
        <template v-if="action.icon" #icon>
          <component :is="action.icon" />
        </template>
        {{ action.label }}
      </a-button>
    </template>
  </a-space>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import type { TableAction } from './DataTable.vue'

interface Props {
  actions: TableAction[]
  record: any
  index: number
}

const props = defineProps<Props>()

const { t } = useI18n()

const emit = defineEmits<{
  'action-click': [action: string, record: any, index: number]
}>()

// 可见的操作
const visibleActions = computed(() => {
  return props.actions.filter(action => {
    if (typeof action.visible === 'function') {
      return action.visible(props.record)
    }
    return action.visible !== false
  })
})

// 获取按钮类型
const getButtonType = (type?: string): 'link' | 'default' | 'primary' => {
  if (type === 'link') return 'link'
  if (type === 'primary') return 'primary'
  return 'default'
}

// 判断是否禁用
const isDisabled = (action: TableAction): boolean => {
  if (typeof action.disabled === 'function') {
    return action.disabled(props.record)
  }
  return action.disabled === true
}

// 处理点击
const handleClick = (action: TableAction) => {
  emit('action-click', action.key, props.record, props.index)
}
</script>

<style scoped lang="less">
// 操作按钮样式
</style>

